import { makeStyles } from '@material-ui/core/styles';

const useProcessPreviewStyles = makeStyles(() => ({
  process_preview_wrapper: {
    paddingTop: '30px',
    '& .process_preview_lineItem': {
      marginBottom: '29px',
      display: 'flex',
      '& .line_numbering': {
        width: '30px',
        height: '30px',
        borderRadius: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: '#ffffff'
      },
      '& .line_process': {
        display: 'inline-grid',
        marginLeft: '10px',
        width: '90%',
        '& .lineTitle': {
          fontWeight: '500'
        },
        '& .lineDescription': {
          fontSize: '14px'
        }
      }
    },
    '& .process_preview_lineItem:nth-child(1)': {
      '& .line_numbering': {
        backgroundColor: 'var(--primary-light)',
      }
    },
    '& .process_preview_lineItem:nth-child(2)': {
      '& .line_numbering': {
        backgroundColor: 'var(--primary-light)',
      }
    },
    '& .process_preview_lineItem:nth-child(3)': {
      '& .line_numbering': {
        backgroundColor: 'var(--teal-blue)',
      }
    },
    '& .process_preview_lineItem:nth-child(4)': {
      '& .line_numbering': {
        backgroundColor: 'var(--teal-blue)',
      }
    },
    '& .process_preview_lineItem:nth-child(5)': {
      '& .line_numbering': {
        backgroundColor: 'var(--teal-blue)',
      }
    },
    '& .process_preview_lineItem:nth-child(6)': {
      '& .line_numbering': {
        backgroundColor: 'var(--primary-dark)',
      }
    },
    '& .process_preview_lineItem:nth-child(7)': {
      '& .line_numbering': {
        backgroundColor: 'var(--primary-dark)',
      }
    },
    '& .process_preview_lineItem:nth-child(8)': {
      '& .line_numbering': {
        backgroundColor: 'var(--primary-dark)',
      }
    }
  }
}));
export default useProcessPreviewStyles;
